import { cn } from "~/lib/utils";

function workspaceInitial(name: string | null | undefined, fallback = ""): string {
  return name?.trim().charAt(0).toUpperCase() || fallback;
}

export function WorkspaceAvatar({
  name,
  iconUrl,
  logoUrl,
  color,
  className,
  fallbackClassName,
}: {
  readonly name: string | null | undefined;
  readonly iconUrl: string | null | undefined;
  readonly logoUrl: string | null | undefined;
  readonly color?: string | null | undefined;
  readonly className: string;
  readonly fallbackClassName?: string;
}) {
  const label = name?.trim() || "Workspace";
  const imageUrl = iconUrl ?? logoUrl ?? null;
  const initial = workspaceInitial(name);
  const fallbackStyle = imageUrl ? undefined : color ? { background: color } : undefined;

  return imageUrl ? (
    <img
      src={imageUrl}
      alt={label}
      title={label}
      className={cn(className, "object-cover")}
      referrerPolicy="no-referrer"
    />
  ) : initial ? (
    <span title={label} className={cn(className, fallbackClassName)} style={fallbackStyle}>
      {initial}
    </span>
  ) : (
    <span aria-hidden="true" title={label} className={className} style={fallbackStyle} />
  );
}
